import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import moment from 'moment'

const View = () => {
  const { id } = useParams()
  const [task, setTask] = useState(null)
  const [loading, setLoading] = useState(true)
  const [comments, setComments] = useState([])
  const [newComment, setNewComment] = useState('')

  const fetchTaskData = async () => {
    try {
      const response = await axiosAuthInstance.get(`task/detail/${id}`)
      setTask(response.data.result)
    } catch (error) {
      console.error('Error fetching task data:', error)
    } finally {
      setLoading(false)
    }
  }

  const fetchComments = async () => {
    try {
      const response = await axiosAuthInstance.get(`task-comment/list`, {
        task: id,
      })
      if (response.status === 200) {
        setComments(response.data.result.docs)
      }
    } catch (error) {
      console.error('Error fetching comments', error)
    }
  }

  const handleAddComment = async () => {
    if (!newComment.trim()) return
    try {
      const response = await axiosAuthInstance.post(`task-comment/add`, {
        task: id,
        comment: newComment,
      })
      if (response.status === 200) {
        setNewComment('')
        fetchComments()
      }
    } catch (error) {
      console.error('Error adding comment:', error)
    }
  }

  useEffect(() => {
    fetchTaskData()
    fetchComments()
  }, [id])

  if (loading) return <div>Loading...</div>
  if (!task) return <div>No task data found.</div>

  return (
    <div className='bg-white text-black shadow-md rounded-lg p-6'>
      <h2 className='text-xl font-semibold mb-4'>Task Details</h2>

      <div className='overflow-x-auto mb-8'>
        <table className='w-full border-collapse'>
          <tbody>
            <tr>
              <td className='border-b px-4 py-2 font-medium'>Task Name</td>
              <td className='border-b px-4 py-2'>{task.name}</td>
            </tr>
            <tr>
              <td className='border-b px-4 py-2 font-medium'>Description</td>
              <td className='border-b px-4 py-2'>{task.description}</td>
            </tr>
            <tr>
              <td className='border-b px-4 py-2 font-medium'>Priority</td>
              <td className='border-b px-4 py-2'>{task.priority}</td>
            </tr>
            <tr>
              <td className='border-b px-4 py-2 font-medium'>Status</td>
              <td className='border-b px-4 py-2'>
                {task?.status?.name || 'Not Started Yet'}
              </td>
            </tr>
            {task.bigButton && (
  <>
    <tr>
      <td className='border-b px-4 py-2 font-medium'>Big Task Type</td>
      <td className='border-b px-4 py-2'>
        {task?.bigTaskType?.name || '-'}
      </td>
    </tr>
    <tr>
      <td className='border-b px-4 py-2 font-medium'>Big Task Status</td>
      <td className='border-b px-4 py-2'>
        {task?.bigTaskStatus?.name || '-'}
      </td>
    </tr>
  </>
)}
            <tr>
              <td className='border-b px-4 py-2 font-medium'>Company</td>
              <td className='border-b px-4 py-2'>{task?.company?.name}</td>
            </tr>
            <tr>
              <td className='border-b px-4 py-2 font-medium'>Added Date</td>
              <td className='border-b px-4 py-2'>
                {moment(task.createdAt).format('DD/MM/YYYY hh:mm A')}
              </td>
            </tr>
            <tr>
              <td className='border-b px-4 py-2 font-medium'>Due Date</td>
              <td className='border-b px-4 py-2'>
                {moment(task.dueDate).format('DD/MM/YYYY hh:mm A')}
              </td>
            </tr>
            <tr>
              <td className='border-b px-4 py-2 font-medium'>
                Final Submitted Date
              </td>
              <td className='border-b px-4 py-2'>
                {task.completionDate
                  ? moment(task.completionDate).format('DD/MM/YYYY hh:mm A')
                  : '-'}
              </td>
            </tr>

            <tr>
              <td className='border-b px-4 py-2 font-medium'>Assign To</td>
              <td className='border-b px-4 py-2'>
                {task?.assignTo?.full_name}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <h3 className='text-lg font-semibold mb-4'>Comments</h3>

        {/* Add Comment */}
        <textarea
          className='w-full p-2 border rounded-lg mb-4'
          rows='4'
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder='Add a comment...'
        />
        <button
          onClick={handleAddComment}
          className='bg-primary text-white px-4 py-2 rounded'
        >
          Add Comment
        </button>

        {/* Comments List */}
        <div className='mt-6 max-h-72 overflow-auto'>
          {comments.length === 0 ? (
            <p>No comments yet.</p>
          ) : (
            <ul className='space-y-4'>
              {comments.map((comment, index) => (
                <li key={index} className='bg-gray-100 p-4 rounded-lg'>
                  <div className='flex justify-between items-center border-b'>
                    <p className='font-semibold'>{comment.addedBy}</p>
                    <span className='text-sm text-gray-500'>
                      {moment(comment.createdAt).format('DD/MM/YYYY HH:mm')}
                    </span>
                  </div>
                  <div className='mt-2 p-2'>
                    <p>{comment.comment}</p>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}

export default View
